import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";

const CardNotificacaoBase = ({ 
    notificacao, 
    icon, 
    color, 
    text, 
    label, 
    titulo, 
    descricao, 
    dataFormatada, 
    onClick 
}) => {
    const [isHovered, setIsHovered] = React.useState(false);

    return (
        <div 
            className="bg-white rounded-3 mb-2 position-relative"
            style={{
                boxShadow: isHovered ? '0 4px 15px rgba(0,0,0,0.05)' : '0 1px 2px rgba(0,0,0,0.03)',
                transform: isHovered ? 'translateY(-2px)' : 'none',
                transition: 'all 0.2s ease',
                cursor: 'pointer',
                border: '1px solid #f0f0f0',
                borderLeft: `4px solid var(--bs-${color})`
            }}
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div className="p-3">
                <div className="d-flex align-items-start">
                    {/* Icon Area */}
                    <div className={`me-3 mt-1 p-2 rounded-circle bg-light d-flex align-items-center justify-content-center ${text}`} 
                         style={{ width: '40px', height: '40px', minWidth: '40px' }}>
                        {React.cloneElement(icon, { size: 16 })}
                    </div>

                    {/* Content Area */}
                    <div className="flex-grow-1">
                        <div className="d-flex justify-content-between align-items-start mb-1">
                            <h6 className="mb-0 fw-semibold text-dark" style={{ fontSize: '0.95rem', letterSpacing: '-0.3px', lineHeight: '1.4' }}>
                                {titulo}
                            </h6>
                            <div className="d-flex align-items-center ms-2">
                                {!notificacao.lida && (
                                     <span 
                                        className="d-inline-block rounded-circle bg-danger me-2" 
                                        style={{ width: '8px', height: '8px', boxShadow: '0 0 0 2px rgba(220, 53, 69, 0.2)' }}
                                        title="Não lida"
                                     />
                                )}
                                <small className="text-muted" style={{ fontSize: '0.75rem', fontWeight: 500, whiteSpace: 'nowrap' }}>
                                    {dataFormatada}
                                </small>
                            </div>
                        </div>
                        
                        <p className="text-muted mb-2 text-truncate-2" style={{ fontSize: '0.85rem', lineHeight: '1.5' }}>
                            {descricao}
                        </p>

                        <div className="d-flex align-items-center justify-content-between">
                            <span 
                                className={`badge bg-light text-${color} border border-${color} border-opacity-10 rounded-pill px-2 py-1 fw-normal`}
                                style={{ fontSize: '0.7rem' }}
                            >
                                {label}
                            </span>
                            
                            {isHovered && (
                                <FaExternalLinkAlt className="text-muted fade-in" size={10} style={{ opacity: 0.5 }} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardNotificacaoBase;
